import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

import { Text, TextField } from '@aws-amplify/ui-react';
import PageBaseNoSignIn from '@components/pages/PageBaseNoSignIn';
import { Button, Grid, Link, Typography } from '@mui/material';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { registMailTokenApi } from '@apis/index';
import { MessageDialogState } from '@atom/DialogState';
import { LoadingState } from '@atom/LoadingState';
import { FacilityState } from '@atom/FacilityState';

import { RegistMailTokenMutationVariables } from '../../../API';

const GroupNewRegisterPage = () => {
  const navigate = useNavigate();
  const setMessageDialogState = useSetRecoilState(MessageDialogState);
  const setLoading = useSetRecoilState(LoadingState);

  // メールアドレス
  const [mailAdress, setMailAdress] = useState<string>('');
  const [mailAddressError, setMailAddressError] = useState<boolean>(false);

  // 確認用メールアドレス
  const [confirmMailAdress, setConfirmMailAdress] = useState<string>('');
  const [confirmMailAddressError, setConfirmMailAddressError] = useState<boolean>(false);
  // Recoilステート
  const facility = useRecoilValue(FacilityState);
  const { facilityId } = facility;
  // 画面遷移時処理
  const register = async () => {
    setLoading(true);
    // API呼び出し
    try {
      const input: RegistMailTokenMutationVariables = {
        input: {
          email: mailAdress,
          facilityId
        }
      };

      // データ取得
      const result = await registMailTokenApi(input);

      // API成功後、遷移
      navigate('/c007/complete');

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      // eslint-disable-next-line no-console
      console.error(error);

      let message = '時間をおいてから再度お試しください。解決できない場合は管理者へお問い合わせください。';
      if ('errors' in error && error.errors.length !== 0) {
        message = error.errors[0].message;
      }
      setMessageDialogState({
        open: true,
        messageData: {
          title: 'エラーが発生しました。',
          message
        }
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {}, []);

  return (
    <PageBaseNoSignIn title="団体新規登録">
      <Grid container spacing={2}>
        <Grid item xs={12} ml={2} mr={2} mt={2}>
          <TextField
            hasError={mailAddressError}
            errorMessage="メールアドレスの形式で入力してください"
            label={
              <Text>
                メールアドレス
                <Text as="span" fontSize="0.8rem" color="red">
                  {'  '}
                  必須
                </Text>
              </Text>
            }
            maxLength={100}
            type="email"
            value={mailAdress}
            placeholder="メールアドレスを入力"
            onChange={(event) => {
              // メールアドレスチェック
              setMailAdress(event.target.value);
              if (!event.target.value.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) {
                setMailAddressError(true);
              } else {
                setMailAddressError(false);
              }
            }}
          />
        </Grid>
        <Grid item xs={12} ml={2} mr={2}>
          <TextField
            hasError={confirmMailAddressError}
            errorMessage="メールアドレスの形式で入力してください"
            label={
              <Text>
                メールアドレス（確認）
                <Text as="span" fontSize="0.8rem" color="red">
                  {'  '}
                  必須
                </Text>
              </Text>
            }
            maxLength={100}
            value={confirmMailAdress}
            placeholder="確認のためもう一度入力をお願いします"
            onChange={(event) => {
              // メールアドレスチェック
              // 単体チェック、複合チェックï
              setConfirmMailAdress(event.target.value);
              if (!event.target.value.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) {
                setConfirmMailAddressError(true);
              } else {
                setConfirmMailAddressError(false);
              }
            }}
          />
        </Grid>
        <Grid item xs={12} m={2}>
          <Text
            variation="primary"
            as="p"
            lineHeight="1.5em"
            fontWeight={400}
            fontSize="1em"
            fontStyle="normal"
            textDecoration="none"
            width="100%"
          >
            <Link href="/" target="_blank" rel="noopener noreferrer">
              利用規約
            </Link>
            と
            <Link href="/" target="_blank" rel="noopener noreferrer">
              プライバシーポリシー
            </Link>
            に同意の上、団体登録を行なってください。
          </Text>
        </Grid>
        <Grid item xs={12} m={2}>
          <Button
            variant="contained"
            fullWidth
            disabled={
              !mailAdress ||
              !confirmMailAdress ||
              mailAddressError ||
              confirmMailAddressError ||
              !(mailAdress === confirmMailAdress)
            }
            onClick={register}
          >
            登録
          </Button>
        </Grid>
        <Grid item xs={12} m={2}>
          <Typography>
            <RouterLink to="/c003/login" state={{ nextPathName: '/c001/arealist' }}>
              ログインはこちら
            </RouterLink>
          </Typography>
        </Grid>
      </Grid>
    </PageBaseNoSignIn>
  );
};

export default GroupNewRegisterPage;
